import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite"
import variables from "../../../../variables/variables"
import Rating from "@mui/material/Rating"
import { themeConfig } from "@gap/shared/theme"
import useWindowSize from "reusable/hooks/useWindowSize"

const marketingContent = {
   invitation: {
      text: `${variables.gapName} doesn't just enable you to offer advisory services to clients, it genuinely makes you a better business and business owner yourself. The structure, resources, and insights it provides have been invaluable in shaping the way we support our clients and grow our own firm.`,
      author: 'Stephen Edwards',
      authorJobTitle: 'Go Profit First Accountants',
      stars: 5
   },
   signUp: {
      text: `It’s saving me so much time, probably an hour per client meeting.`,
      author: 'Mark Said',
      authorJobTitle: 'Founding Director, MKS Group',
      stars: 5
   }
}

export default observer(function SignUpAdvisorMarketingContent({ isInvitation }: { isInvitation: boolean }) {
   const content = isInvitation ? marketingContent.invitation : marketingContent.signUp
   const { width } = useWindowSize()
   const isSidePanel = width > themeConfig.breakpoints.values.desktop

   const testimonial = <>
      <img src="/images/icons/left-quote.png" alt="" width={26} />
      <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
         {content.text}
      </Typography>
      <Stack sx={{ marginTop: 4 }}>
         <Rating value={content.stars} readOnly size="medium" sx={{
            color: themeConfig.passion,
            'svg': {
               width: '24px',
               height: '24px',
            }
         }} />
         <Typography variant="body1" sx={{ marginTop: 2, opacity: 0.7 }}>
            <strong>{content.author}</strong> | {content.authorJobTitle}
         </Typography>
      </Stack>
   </>

   const ned = !isInvitation && (
      <Box
         component="img"
         src="/images/ned-with-marker.webp"
         alt={`Ned, ${variables.gapName}'s elephant mascot`}
         sx={{ alignSelf: 'flex-end', mt: 4, width: isSidePanel ? 300 : 200, maxWidth: isSidePanel ? '50%' : '100%' }}
      />
   )

   if (!isSidePanel) {
      return <Stack sx={{ maxWidth: '600px' }}>
         {testimonial}
         {ned}
      </Stack>
   }

   return <Stack sx={{ flexGrow: 1, alignSelf: 'stretch' }}>
      <Stack sx={{ flexGrow: 1, justifyContent: 'center', maxWidth: '600px', pt: 24 }}>
         {testimonial}
      </Stack>
      {ned}
   </Stack>
})